import VolunteerComponent from "@/components/Volunteer/VolunteerComponent";

const Volunteer = () => {
  return <VolunteerComponent />;
};

export default Volunteer;
